/**
 * Vinci — fix robuste pour l'état sticky du header transparent.
 * Remplace la détection native (IntersectionObserver threshold:1, peu fiable
 * en combinaison avec transparent + sticky:'always') par une simple lecture
 * du scroll, recalculée à chaque scroll, sans dépendre d'un état précédent.
 */
(function () {
  function init() {
    var header = document.getElementById('header-component');
    if (!header || header.dataset.vinciStickyFixed === 'true') return;
    header.dataset.vinciStickyFixed = 'true';

    var THRESHOLD = 4; // px de scroll avant de considérer le header "actif"
    var ticking = false;

    function update() {
      var scrollTop = document.scrollingElement
        ? document.scrollingElement.scrollTop
        : window.scrollY || 0;

      var nextState = scrollTop > THRESHOLD ? 'active' : 'inactive';

      // Toujours réévaluer, jamais de court-circuit sur l'état précédent
      if (header.dataset.stickyState !== nextState) {
        header.dataset.stickyState = nextState;
      }

      ticking = false;
    }

    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });

    // État correct dès le chargement (ex: retour arrière navigateur, ancre, etc.)
    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init si Shopify réhydrate la section (ex: retour sur la home via prefetch)
  document.addEventListener('shopify:section:load', init);
})();
